export default "__VITE_ASSET__DtRxhW73__"